import React from 'react';

import SliderPromo from '../../components/SliderPromo/SliderPromo';
import OfertasDestacadas from '../../components/OfertasDestacadas/OfertasDestacadas';
import Services from '../../components/Services/Services';
import CarouselHome from '../../components/Carousel/Carousel';

// import MainSearch from '../../components/MainSearch/MainSearch';
// import { Promos } from '../../components/Promos/Promos';

const Home = () => {
  return (
    <>
      <CarouselHome />
      <OfertasDestacadas />
      {/* <MainSearch /> */}
      {/* <Promos /> */}
      {/* <SliderPromo /> */}
      <Services />
    </>
  );
};

export default Home;
